import { styled } from '@mui/material/styles';

import { MenuItem } from '@/shared/ui';

export const StyledMenuItem = styled(MenuItem)({
  padding: '6px',
});
